import axios from "axios";

const apiMo = axios.create({
    //baseURL : 'http://localhost:3021/api-mo'
    baseURL : 'https://api-mundopticos.codiceinnova.com/api-mo'
})

export default apiMo